import React, {Component} from 'react';
import styles from './index.css';
import fonts from '../../../../../iconfonts.css';
import FontAwesome from 'react-fontawesome';
import {Popup} from '../index';
import {observer} from 'mobx-react';

@observer
export default class RailCart extends Component{
    static defaultProps={
        deleteTransport:()=>{console.log('none event')},
        item:{transportStatus:'none',moistureLevel:0,wasteLevel:0,culture:'soy',groupQuantity:10,amount:0}
    };
    state = {active:false};
    coords(e){
        let target = e.target;
        let X = target.getBoundingClientRect().right + 5;
        let Y = target.getBoundingClientRect().top - 10;
        this.setState({active:true,x:X,y:Y})
    }

  render(){
      let item =this.props.item;
      let railCartLevel = {height: item.amount*2.3/48 + 'rem'};
      return (
          <div className={styles.railCartContainer} onMouseOver={this.coords.bind(this)} onMouseLeave={()=>this.setState({active:false})}>
            <div className={styles.railCart}>
                {/*<div*/}
                    {/*className={styles.railCartStatus + (item.transportStatus ? ' ' + styles[item.transportStatus] : '')}/>*/}
                <div className={styles.cultureArea}>
                    <div className={styles.railCartLevel + (item.culture ? ' ' + styles[item.culture] : '')}
                         style={railCartLevel}>
                    </div>
                    <div className={styles.railCartCulture}>
                        <i className={fonts[item.culture]}/>
                    </div>
                    <div className={styles.railCartNumbers}>
                        <span>{Math.floor(item.moistureLevel)}%</span>
                        <span>{Math.floor(item.wasteLevel)}%</span>
                    </div>
                    <div
                        className={(item.groupQuantity ? styles.railCartQuantity : styles.hideQuantity)}>{item.groupQuantity}</div>
                    <div className={styles.railCartDefinitions}>
                        <span><FontAwesome name='tint'/></span>
                        <span><FontAwesome name='trash'/></span>
                    </div>
                </div>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0"
                   y="0px" viewBox="0 0 140 50">
                <path className={styles.railCartBase} d="M137,12.9L132.2,0l-1.1,2.8l3.8,10.1h-9.6c-1.5-1.8-3.7-3-6.2-3c-3.7,0-6.8,2.6-7.7,6h-3.5c-0.9-3.4-4-6-7.7-6
           s-6.8,2.6-7.7,6H47.7c-0.9-3.4-4-6-7.7-6s-6.8,2.6-7.7,6h-3.5c-0.9-3.4-4-6-7.7-6c-2.5,0-4.8,1.2-6.2,3H5.1L8.9,2.8L7.8,0L3,12.9H0
           v3h9l1,3h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7H51l0.7-2h36.7l0.7,2h3.1
           c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1c0.5,3.9,3.9,7,7.9,7s7.4-3.1,7.9-7h3.1l1-3h9v-3H137z M21,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2
           s2,0.9,2,2S22.1,19.9,21,19.9z M40,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S41.1,19.9,40,19.9z M100,19.9c-1.1,0-2-0.9-2-2
           s0.9-2,2-2s2,0.9,2,2S101.1,19.9,100,19.9z M119,19.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S120.1,19.9,119,19.9z"/>
              </svg>
            </div>
              {this.state.active ?
                  <Popup x={this.state.x} y={this.state.y} item={item}/> : null
              }
          </div>
      )
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/RailCart/index.js